// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1xoPz","bigColWidth":"Table_bigColWidth__25b7B","biggerColWidth":"Table_biggerColWidth__2HDCH","row":"Table_row__eoVyL","col":"Table_col__32-cF"};